module.exports = __webpack_public_path__ + "static/media/15_Cancel Appointment.4f639620.jpg";